'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBeachAccess = function MdBeachAccess(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.1 14.7c-5.3-5.2-12.5-7-19.1-4.8 5-0.6 11.4 2 16.6 7.2l-9.5 9.5c-5.2-5.2-7.8-11.6-7.2-16.6-2.2 6.6-0.4 13.8 4.8 19.1l-4.8 4.7c-6.5-6.5-6.5-17.2 0-23.8 0-0.1 0-0.1 0.1-0.1 6.6-6.5 17.3-6.5 23.8 0z m-7.2 9.6l2.4-2.4 10.7 10.8-2.4 2.3z' })
        )
    );
};

exports.default = MdBeachAccess;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/beach-access.js
// module id = 2640
// module chunks = 0